import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export default class GetLastSearchesAdsUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.repository
   */
  constructor({repository}) {
    super({repository})
    this._repository = repository
  }

  /**
   * @return {Promise<Object, Error>} list of searches
   */
  async execute() {
    const lastSearchesVO = await this._repository.getLastAdsSearches()
    return lastSearchesVO.toJSON()
  }
}
